import { Component, Input, OnInit } from '@angular/core';

import { AppPlacement } from 'src/app/core/types/app-placement.type';

@Component({
    selector: 'app-expand-item',
    templateUrl: './expand-item.component.html',
    styleUrls: ['./expand-item.component.scss'],
    standalone: false
})
export class ExpandItemComponent implements OnInit {

  @Input() model: any;
  @Input() title: any;
  @Input() isCustom: boolean = false;
  @Input() placement: AppPlacement = "left";

  fontClass: any;

  constructor() { }

  ngOnInit() {
    this.fontClass = "fas fa-chevron-" + this.placement;
  }

}
